import { Field } from 'Util/Query';

/** @namespace Pwa/Query/ProductTags/Query */
export class ProductTagsQuery {
    getProductTagsQuery(product_id) {
        return new Field('productTagsByProductId')
            .addArgument('product_id', 'Int!', product_id)
            .addField(new Field('items').addFieldList(['tag_code', 'image_url']));
    }
}

export default new ProductTagsQuery();
